import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectablePill } from './SelectablePill';
import { APP_OTHER_API_ID, APPS } from './onboardingOptions';
import { useGettingStartedOnboarding } from './useGettingStartedOnboarding';
import { Input } from '@/Domain/components/Shared/Input/Input';

export const ExternalAppsStep = () => {
  const { t } = useTranslation('getting_started');
  const {
    externalAppsSelection,
    toggleExternalApp,
    externalAppsOtherText,
    setExternalAppsOtherText,
  } = useGettingStartedOnboarding();
  const otherApiSelected = externalAppsSelection.has(APP_OTHER_API_ID);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap gap-2" data-testid="gs-external-apps-pills">
        {APPS.map((app) => (
          <SelectablePill
            key={app.id}
            label={app.label}
            icon={app.icon}
            iconColor={app.iconColor}
            selected={externalAppsSelection.has(app.id)}
            onToggle={() => toggleExternalApp(app.id)}
            testId={`gs-external-apps-pill-${app.id}`}
          />
        ))}
      </div>
      {otherApiSelected && (
        <Input
          type="text"
          value={externalAppsOtherText}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setExternalAppsOtherText(e.target.value)}
          placeholder={t('external_apps_step.other_api_placeholder')}
          maxLength={200}
          autoComplete="off"
          data-testid="gs-external-apps-other-input"
        />
      )}
    </div>
  );
};
